import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Skills = () => {
  const skillsRef = useRef(null);
  const ctxRef = useRef(null);

  const skills = [
    { name: "React", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
    { name: "Node.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" },
    { name: "JavaScript", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" },
    { name: "PHP", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg" },
    { name: "MySQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" },
    { name: "MongoDB", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" },
    { name: "Express.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg" },
    { name: "WordPress", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wordpress/wordpress-original.svg" },
    { name: "Shopify", icon: "https://cdn.shopify.com/shopifycloud/brochure/assets/brand-assets/shopify-logo-shopping-bag-full-color-66166b2e55d67988b56b4bd28b63c271e2b9713358cb723070a92bde17ad7d63.svg" },
    { name: "HTML", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" },
    { name: "CSS", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" },
    { name: "Bootstrap", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg" },
    { name: "Tailwind", icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/tailwindcss/tailwindcss-original.svg" },
    { name: "Photoshop", icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/photoshop/photoshop-plain.svg" },
    { name: "Canva", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/canva/canva-original.svg" },
    { name: "Illustrator", icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/illustrator/illustrator-plain.svg" },
    { name: "GitHub", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg" },
  ];

  useEffect(() => {
    if (!skillsRef.current) return;

    ctxRef.current = gsap.context(() => {
      const items = gsap.utils.toArray(".skill-anim");

      // Start hidden
      gsap.set(items, { autoAlpha: 0, y: 30 });

      ScrollTrigger.batch(items, {
        start: "top 80%",
        once: true, // Animate only once
        onEnter: (batch) => {
          gsap.to(batch, {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            ease: "power2.out",
            stagger: 0.08,
          });
        },
      });
    }, skillsRef);

    return () => ctxRef.current && ctxRef.current.revert();
  }, []);

  return (
    <>
      <h3 className="text-2xl tracking-tight text-text-light">Technical Skills</h3>
      <p className="sr-only">
        Technologies and tools used by Bhavya Kansara for web development,
        frontend engineering, backend development, and graphic design projects.
      </p>

      <div className="mt-3 border-t border-l border-white/15 w-full overflow-visible">
        <div ref={skillsRef} className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 w-full">
          {skills.map((skill, index) => (
            <div
              key={index}
              className="skill-item group relative p-8 bg-text-light/5 border-b border-r border-white/15 hover:bg-accent/20 transition-all duration-300 cursor-pointer flex items-center justify-center"
            >
              {/* animate this inner wrapper only */}
              <div className="skill-anim flex flex-col items-center gap-2">
                <img
                  src={skill.icon}
                  alt={`${skill.name} logo`}
                  className={`w-12 h-12 object-contain transition-transform duration-300 ${['Express.js', 'GitHub', 'WordPress', 'Shopify'].includes(skill.name) ? 'bg-white p-1 rounded-sm' : ''}`}
                />
                <span className="text-center text-base leading-relaxed text-text-light">{skill.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Skills;
